var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container" }, [
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-12 mb-1 text-center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-center" }, [
          _c(
            "span",
            {
              staticClass: "h4 shiny-text",
              staticStyle: { "padding-top": "5px" }
            },
            [_vm._v("SHINY HOME BY BENEAT")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-column align-content-center pl-1 btn",
              on: { click: _vm.openInfo }
            },
            [
              _c("i", {
                staticClass: "fa fa-info-circle p-0",
                staticStyle: { color: "#616161" }
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-size": "9px", color: "#616161" } },
                [_vm._v("รายละเอียด")]
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-6 form-group text-center example-snap" },
        [
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body text-center" },
              [
                _c("b-img-lazy", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: "/static/img/snapAndShare/snap_and_share_example.jpg",
                    alt: ""
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-md-6" },
        [
          _c(
            "b-form",
            {
              attrs: { "data-vv-scope": "form-snapAndShare" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-12 form-group" },
                  [
                    _c("label", { attrs: { for: "tel" } }, [
                      _vm._v("เบอร์โทร"),
                      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                    ]),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "form-control",
                      attrs: {
                        id: "tel",
                        type: "tel",
                        state: _vm.state,
                        placeholder: "เบอร์โทร (กรอกเฉพาะตัวเลขและพิมพ์ติดกัน)",
                        required: "",
                        "aria-describedby": "input-live-feedback"
                      },
                      model: {
                        value: _vm.formReview.tel,
                        callback: function($$v) {
                          _vm.$set(_vm.formReview, "tel", $$v)
                        },
                        expression: "formReview.tel"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-form-invalid-feedback",
                      { attrs: { id: "input-live-feedback" } },
                      [
                        _vm._v(
                          "\n              กรุณากรอกเบอร์โทรศัพท์\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-12 form-group" },
                  [
                    _c("label", { attrs: { for: "link-review" } }, [
                      _vm._v("Link Post คุณลูกค้า"),
                      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                    ]),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "form-control",
                      attrs: {
                        id: "link-review",
                        type: "text",
                        placeholder: "",
                        state: _vm.stateUrl,
                        required: "",
                        "aria-describedby": "input-live-feedback-url-review"
                      },
                      model: {
                        value: _vm.formReview.url_review,
                        callback: function($$v) {
                          _vm.$set(_vm.formReview, "url_review", $$v)
                        },
                        expression: "formReview.url_review"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-form-invalid-feedback",
                      { attrs: { id: "input-live-feedback-url-review" } },
                      [
                        _vm._v(
                          "\n              กรุณากรอก Link Post\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-12 form-group" },
                  [
                    _c("label", { attrs: { for: "order-code" } }, [
                      _vm._v("รหัสการจอง (optional)")
                    ]),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "form-control",
                      attrs: { id: "order-code", type: "text" },
                      model: {
                        value: _vm.formReview.order_code,
                        callback: function($$v) {
                          _vm.$set(_vm.formReview, "order_code", $$v)
                        },
                        expression: "formReview.order_code"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("picture-input", {
                      ref: "pictureInput",
                      attrs: {
                        width: "300",
                        height: "200",
                        accept:
                          "image/jpeg,image/png,image/gif,image/svg,image/webp",
                        size: "5",
                        removable: true,
                        customStrings: {
                          upload: "<p>อัพโหลดเรียบร้อย</p>",
                          drag: "อัพโหลดรูป",
                          tap: "อัพโหลดรูป",
                          change: "เปลี่ยนรูป",
                          remove: "ลบรูป"
                        },
                        zIndex: 1000
                      },
                      on: { change: _vm.onChange, remove: _vm.onRemove }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "mb-3 mt-5" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block btn-info",
                          attrs: { type: "submit", disabled: _vm.isSubmitting }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.isSubmitting
                                  ? "กำลังส่งรีวิว..."
                                  : "ส่งรีวิว"
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "h1 text-style" }, [_vm._v("แชะ")]),
      _vm._v(" "),
      _c("span", { staticClass: "sub-text-style" }, [_vm._v("AND")]),
      _vm._v(" "),
      _c("span", { staticClass: "h1 text-style" }, [_vm._v("แชร์")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header text-center" }, [
      _c("h3", { staticStyle: { margin: "0" } }, [
        _vm._v("ตัวอย่าง การอัพโหลดรูป")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-291d6234", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291d6234","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/snapAndShare/index.vue
// module id = 2392
// module chunks = 0